import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Badge } from 'reactstrap';

export interface Props {
  className?: string;
}

export const PrivateDataBadge: FC<Props> = (props) => (
  <Badge
    pill
    className={
      'py-2 badge rounded-pill me-2 bg-warning-soft text-uppercase' +
      (props.className ? ` ${props.className}` : '')
    }
  >
    <i className="fe fe-lock" />
    <FormattedMessage
      id="app.views.shared_componentes.badges.private_data"
      defaultMessage="Private"
    />
  </Badge>
);
